import { React, useState, useEffect, useContext } from 'react'
import { FaEdit } from "react-icons/fa";
import { Col, Row, FormGroup, Label, Input, Form, Table, NavLink } from 'reactstrap';
import SubHeader from './SubHeader';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import Slidebar from './Slidebar';
import { GlobalContext } from '../../App';
import TopHeader from './TopHeader';
import { BsChevronRight } from "react-icons/bs";
import { InfinitySpin } from "react-loader-spinner";
import { useNavigate, useLocation } from "react-router-dom";
function ManageRole(openSubmenu) {
    const navigate = useNavigate();
    const body = document.body;
    const mainPanel = document.querySelector('.main-panel');
    const maskBgOverlay = document.createElement('div');
    maskBgOverlay.id="maskBgOverlay";
    maskBgOverlay.className = 'maskBgOverlay';
    const location = useLocation();
    const { pathname } = location;
    const [RoleData, setRoleData] = useState([]);
    const [tempCRUD2, settempCRUD2] = useState([]);
    const [ModuleData, setModuleData] = useState([]);
    // const [isActive, setisActive] = useState(false);
    const [open3, setOpen3] = useState(false);
    const [modal, setModal] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [RoleDataOption, setRoleDataOption] = useState([]);
    const [id, setId] = useState();
    // const [userRoles, setUserRoles] = useState([]);
    const [ActiveStatus, SetActiveStatus] = useState('1');
    const { rolexModuleData,roles,user_id } = useContext(GlobalContext);
    const [loading, setLoading] = useState(true); 
     // Handle Error
  const handleError = (error) => {
    setLoading(false);
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";
    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };
    // ----------------------------------------------------------- Get Roles --------------------------------------
    const getRoleList = () => {
        setLoading(true);
        axios.get('/getRoleList').then((response)=>{
            setRoleData(response?.data?.filter((item)=> item?.id !== 1001));
            for (let i = 0; i < response?.data.length; i++) {
                RoleDataOption.push({ label: response?.data[i]?.role, value: response?.data[i]?.id })
            }
            setLoading(false);
        }).catch(handleError);
      };
    // ------------------------------------------------------------ Get Module -------------------------------------
    const getModule = () => {
        setLoading(true);
            axios.get('/getModule').then((response)=>{
                setModuleData(response?.data);
                setLoading(false);
            }).catch(handleError);
    }
    // ------------------------------------------------------------ Get Role X Module ------------------------------
    const getRoleXModule = (id) => {
        setLoading(true);
            const params = {
                id: id
            }
            axios.post('/getRoleXModule', params).then((response)=>{
                if (response) {
                    for (let i = 0; i < response?.data?.length; i++) {
                        settempCRUD2(response?.data)
                    }    
                    checkAllStatus(response?.data);
                    setLoading(false);}
            }).catch(handleError);
    }
    var createCheck = 0;
    var readCheck = 0;
    var deleteCheck = 0;
    var updateCheck = 0;
    var specialCheck = 0;
    const checkAllStatus = (data) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].create === 1) {
                createCheck++;
            }
            if (data[i].read === 1) {
                readCheck++;
            }
            if (data[i].update === 1) {
                updateCheck++;
            }
            if (data[i].delete === 1) {
                deleteCheck++;
            }
            if (data[i].special === 1) {
                specialCheck++;
            }
        }
        if (data.length === ModuleData.length) {
            setCheckAll({ ...checkAll, create: (createCheck === data.length), read: (readCheck === data.length), update: (updateCheck === data.length), delete: (deleteCheck === data.length), special: (specialCheck === data.length) });
        }
    }
    const setCrudOps = (event, data) => {
        const dataArray = [...tempCRUD2];
        if (dataArray?.find((item)=> item?.module_id === data?.id)) {
            dataArray?.filter((item)=> item?.module_id === data?.id)?.map(
                (item) => item[event.target.name]  =  event.target.checked ? 1 : 0
            )
        }
        else {
            dataArray.push({ "module_id": data?.id, [event.target.name]: event.target.checked ? 1 : 0 })
        }
        settempCRUD2(dataArray);
        checkAllStatus(dataArray);
    };
// ------------------------------------------------ Role Update -----------------------------------------------
    const RoleUpt = (id) => {
        for (var i = 0; i < (RoleData.length); i++) {
            if (RoleData[i]?.id === id) {
                setGlobalState({ ...globalState, roleName: RoleData[i]?.role, roleDesc: RoleData[i]?.description });
                SetActiveStatus(RoleData[i]?.isActive);
            }
        }
        setId(id);
        getRoleXModule(id);
        handleClickOpen3();
    }

    const setAll = (id) => {
        const dataArray = [...tempCRUD2];
        if (id === '1') {

            for (let i = 0; i < ModuleData.length; i++) {
                if (dataArray[i] && dataArray[i]["module_id"] && (dataArray[i]["module_id"] === ModuleData[i].id)) {
                    dataArray[i]["create"] = checkAll.create ? 0 : 1;
                }
                else {
                    dataArray.push({ "module_id": ModuleData[i].id, create: checkAll.create ? 0 : 1 })
                }
            }
            setCheckAll({ ...checkAll, create: !checkAll.create })
        }
        if (id === '2') {
            for (let i = 0; i < ModuleData.length; i++) {
                if (dataArray[i] && dataArray[i]["module_id"] && (dataArray[i]["module_id"] === ModuleData[i].id)) {
                    dataArray[i]["read"] = checkAll.read ? 0 : 1;
                }
                else {
                    dataArray.push({ "module_id": ModuleData[i].id, read: checkAll.read ? 0 : 1 })

                }
            }
            setCheckAll({ ...checkAll, read: !checkAll.read })
        }
        if (id === '3') {
            for (let i = 0; i < ModuleData.length; i++) {
                if (dataArray[i] && dataArray[i]["module_id"] && (dataArray[i]["module_id"] === ModuleData[i].id)) {
                    dataArray[i]["update"] = checkAll.update ? 0 : 1;
                }
                else {
                    dataArray.push({ "module_id": ModuleData[i].id, update: checkAll.update ? 0 : 1 })
                }
            }
            setCheckAll({ ...checkAll, update: !checkAll.update })
        }
        if (id === '4') {
            for (let i = 0; i < ModuleData.length; i++) {
                if (dataArray[i] && dataArray[i]["module_id"] && (dataArray[i]["module_id"] === ModuleData[i].id)) {
                    dataArray[i]["delete"] = checkAll.delete ? 0 : 1;
                }
                else {
                    dataArray.push({ "module_id": ModuleData[i].id, delete: checkAll.delete ? 0 : 1 })
                }
            }
            setCheckAll({ ...checkAll, delete: !checkAll.delete })
        }
        if (id === '5') {
            for (let i = 0; i < ModuleData.length; i++) {
                if (dataArray[i] && dataArray[i]["module_id"] && (dataArray[i]["module_id"] === ModuleData[i].id)) {
                    dataArray[i]["special"] = checkAll.special ? 0 : 1;
                }
                else {
                    dataArray.push({ "module_id": ModuleData[i].id, special: checkAll.special ? 0 : 1 })
                }
            }
            setCheckAll({ ...checkAll, special: !checkAll.special })
        }
        settempCRUD2(dataArray);
    }

    const handleClickOpen3 = () => {
        setOpen3(true);
        body.style.overflow = "hidden";
        mainPanel.appendChild(maskBgOverlay);
    };

    const [checkAll, setCheckAll] = useState({
        create: false,
        read: false,
        update: false,
        delete: false,
        special:false

    });

    const [globalState, setGlobalState] = useState({
        moduleName: null,
        moduleDesc: null,
        roleName: null,
        roleDesc: null,

    });
    
    // ----------------------------------------------------------- Handle Close ---------------------------------------
    const handleClose = () => {
        setModal(false);
        setIsFilter(false);
        setGlobalState({
            ...globalState,
            roleName: null,
            roleDesc: null,
            moduleName: null,
            moduleDesc: null
        });
        settempCRUD2([]);
        setCheckAll({
            ...checkAll,
            read: false,
            update: false,
            create: false,
            delete: false,
            special:false
        });
        SetActiveStatus('1');
        setOpen3(false);
        setId();
        body.style.overflow = "";
        document.getElementById("maskBgOverlay").remove();
    }
  const toggleModal = () => {
    setIsFilter(false);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  }
  const toggleFilter = () => {
    setIsFilter(true);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  }
// ----------------------------------------------------------- Post Role --------------------------------------------
    const postrole = () => {
            if (globalState.roleName === null || globalState.roleName === "") {
                toast.error("Role name is required!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            else if (globalState.roleDesc === null || globalState.roleDesc === "") {
                toast.error("Role description is required!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            else if (tempCRUD2?.length <= 0) {
                toast.error("Atleat home read access is required!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            else if (!tempCRUD2?.find((item)=> item?.read === 1 && item?.module_id === 2001)) {
                toast.error("Atleat home read access is required!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            else {
                const params = {
                    role: globalState.roleName,
                    description: globalState.roleDesc,
                    access: tempCRUD2,
                    isActive: ActiveStatus,
                    user_id:user_id
                }
                axios.post('/postRole', params).then((response)=>{
                    if (response.status === 202) {
                        toast.error("User role already exist!", {
                            position: toast.POSITION.TOP_RIGHT,
                            theme: "colored",
                            autoClose: 2000
                        });
                    }
                    else {
                        toast.success("User role is created successfully!", {
                            position: toast.POSITION.TOP_RIGHT,
                            theme: "colored",
                            autoClose: 2000
                        });
                        handleClose();
                        getRoleList();
                    }
                }).catch(handleError);
            }
    }
// ----------------------------------------------------------- Update Role ------------------------------------------
    const updaterole = () => {
            if (globalState.roleName === null || globalState.roleName === "") {
                toast.error("Role name is required!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            else if (globalState.roleDesc === null || globalState.roleDesc === "") {
                toast.error("Role description is required!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            else if (tempCRUD2?.length <= 0) {
                toast.error("Atleat home read access is required!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            else if (!tempCRUD2?.find((item)=> item?.read === 1 && item?.module_id === 2001)) {
                toast.error("Atleat home read access is required!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
            else {
                const params = {
                    role: globalState.roleName,
                    description: globalState.roleDesc,
                    access: tempCRUD2,
                    isActive: ActiveStatus,
                    id: id,
                    user_id:user_id
                }
                axios.post('/updateRole', params).then((response)=>{
                    if (response.status === 202) {
                        toast.error("User role already exist!", {
                            position: toast.POSITION.TOP_RIGHT,
                            theme: "colored",
                            autoClose: 2000
                        });
                    }
                    else {
                        toast.success("User role is updated successfully!", {
                            position: toast.POSITION.TOP_RIGHT,
                            theme: "colored",
                            autoClose: 2000
                        });
                        handleClose();
                        getRoleList();
                    }
                }).catch(handleError);
            }
    }

 // ---------------------------------------------------------- Mantain Log History ------------------------------
const postLogHistory = () =>{
    const param = {
      user_id : user_id,
      module_name : 'Manage Role',
      operationPerformed : 'navigate to manage role screen',
    }
    axios.post('/postLogHistory',param);
  }
  
// --------------------------------------------------------------------- Use Effect --------------------------------------
    useEffect(() => {
        getModule();
        getRoleList();
        // postLogHistory();
    }, []);
    //  ----------------------------------------------------------------- set User Content ------------------------------
    const roleContent = <Form name="personal-info-details" className='modelform' >
        <Row>
            <Col md={6}>
                <FormGroup>
                    <Label htmlFor="role_name">
                        Role Name
                    </Label>
                    <Input id="roleName" name="roleName" type="text" value={globalState?.roleName || ""} onChange={(e) => setGlobalState({ ...globalState, roleName: e.target.value })} placeholder='Role Name ' />
                </FormGroup>
            </Col>
            <Col md={6}>
                <FormGroup>
                    <Label htmlFor="role_desc">
                        Role Description
                    </Label>
                    <Input id="roleDesc" name="roleDesc" type="text" value={globalState?.roleDesc || ""} onChange={(e) => setGlobalState({ ...globalState, roleDesc: e.target.value })} placeholder='Role Description' />
                </FormGroup>
            </Col>

            <Col md={6}>
                <FormGroup>
                    <Label htmlFor="role_desc">
                        Status:
                    </Label>
                    <div onChange={(e) => SetActiveStatus(e.target.value)}  >
                        <div className="d-inline-block m-2"><input type="radio" id="isActive" name="status" value='1' checked={ActiveStatus === '1'} /> Active</div>
                        <div className="d-inline-block"><input type="radio" id="isInactive" name="status" value='0' checked={ActiveStatus === '0'} /> Inactive</div>
                    </div>
                </FormGroup>
            </Col>
            <Col md={12}>
                <Table striped responsive>
                    <thead>
                        <tr>
                            <td colSpan="2"><span className="font-weight-bold">Select All</span></td>
                            {/* <td></td> */}
                            <td align="center"><input id="createAll" name="createAll" type="checkbox" checked={checkAll?.create} onChange={() => setAll('1')} /></td>
                            <td align="center"><input id="readAll" name="readAll" type="checkbox" checked={checkAll?.read} onChange={() => setAll('2')} /> </td>
                            <td align="center"><input id="updateAll" name="updateAll" type="checkbox" checked={checkAll?.update} onChange={() => setAll('3')} /></td>
                            <td align="center"><input id="deleteAll" name="deleteAll" type="checkbox" checked={checkAll?.delete} onChange={() => setAll('4')} /></td>
                            <td align="center"><input id="specialAll" name="specialAll" type="checkbox" checked={checkAll?.special} onChange={() => setAll('5')} /></td>
                        </tr>
                        <tr>
                            <th className="text-center" style={{ width: "3" }}>Module ID</th>
                            <th className="text-center">Module Name</th>
                            <th className="text-center">Create</th>
                            <th className="text-center">Read</th>
                            <th className="text-center">Update</th>
                            <th className="text-center">Delete</th>
                            <th className="text-center">Special</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ModuleData ?
                            ModuleData?.map((data, index) =>

                                <tr >
                                    <td align="center" >{data?.id}</td>
                                    <td align="center" >{data?.module}</td>
                                    <td align="center" ><input id="create" name="create" type="checkbox" checked={tempCRUD2?.find((item)=> item?.create === 1 && item?.module_id === data?.id) || false} onChange={(event) => setCrudOps(event, data)} /></td>
                                    <td align="center" ><input id="read" name="read" type="checkbox" checked={tempCRUD2?.find((item)=> item?.read === 1 && item?.module_id === data?.id) || false} onChange={(event) => setCrudOps(event, data)} /></td>
                                    <td align="center" ><input id="update" name="update" type="checkbox" checked={tempCRUD2?.find((item)=> item?.update === 1 && item?.module_id === data?.id) || false} onChange={(event) => setCrudOps(event, data)} /></td>
                                    <td align="center"><input id="delete" name="delete" type="checkbox" checked={tempCRUD2?.find((item)=> item?.delete === 1 && item?.module_id === data?.id) || false} onChange={(event) => setCrudOps(event, data)} /></td>
                                    <td align="center"><input id="special" name="special" type="checkbox" checked={tempCRUD2?.find((item)=> item?.special === 1 && item?.module_id === data?.id) || false} onChange={(event) => setCrudOps(event, data)} /></td>
                                </tr>

                            ) : null}
                    </tbody>
                </Table>
            </Col>
        </Row>
    </Form>
// ---------------------------------------------------------------------- HTML Start ------------------------------------
    return (
        loading ? (
            <div className="loader">
            <InfinitySpin width="200" color="#D81159" />
          </div>
          ) :
     (   <>    
        <TopHeader
    breadCrumb = {
      <>
          <li className="nav-item"><a onClick={() => navigate("/home")} className="nav-link">Home <BsChevronRight /></a></li> 
          <li className="nav-item"><span>Manage Roles</span></li>
      </>
    }/>
         <SubHeader 
                SubHeaderTitle="Manage Roles"
                openSidebar={modal} 
                isFilter={isFilter}
                handleClose={handleClose}
                toggleModal={toggleModal}
                toggleFilter={toggleFilter}
                handleSubmit={postrole} 
                titleButton={`${id ?'Edit':'Add'} Role`}
                showButton={((rolexModuleData?.find((data) => pathname === data?.description && data?.create === 1)) || roles?.find((data) => data?.role_id === 1001)) ? true : false} 
                AddUserContent={roleContent} 
            />
            <div className='managerole-wrap contentInnerWrap'>
                <div className='managerole'>
                    <div className='manage-table'>
                            <Table striped responsive>
                                <thead>
                                    <tr>
                                        <th style={{ width: "3" }}>Role ID</th>
                                        <th>Role Name</th>
                                        <th>Role Description</th>
                                        <th>Status</th>
                                        <th>Created on</th>
                                        <th>Updated on</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {RoleData ?
                                        RoleData?.map(data =>
                                            <tr>
                                                <th scope="row">{data?.id}</th>
                                                <td>{data?.role}</td>
                                                <td>{data?.description}</td>
                                                <td>{(data?.isActive === '1') ? "Active " : "Inactive"}</td>
                                                <td> {new Date(data?.createdDate.split('T')?.[0])?.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
                                                <td>{new Date(data?.updatedDate.split('T')?.[0])?.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
                                                {((rolexModuleData?.find((data) => pathname === data?.description && data?.update === 1) ) || roles?.find((data) => data?.role_id === 1001))?
                                                    <td>
                                                        <NavLink className='edit' onClick={() => RoleUpt(data?.id)}><FaEdit /></NavLink>
                                                    </td> : <td>-</td>}
                                            </tr>
                                        ) : null}
                                </tbody>
                            </Table>
                    </div>
                </div>
            </div>
            <Slidebar openSidebar={open3} title="Edit Role" handleClose={handleClose} handleSubmit={updaterole} content={roleContent} />
        </>)
    )
}

export default ManageRole